import axios from 'axios';

export const backupApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/backup`,
    headers: {
        'Content-Type': 'application/json'
    }
})